import config from '../../config/config.js';

const serverUrl = config.serverUrl;
const BASE_URL = serverUrl; //"http://localhost:8006"

const analyticsConfig = [
    {
        tabName: "Driver Earnings", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/driver_earnings`, // API endpoint
        searchKey: "driver_id",
        showUserId:true,
        columns: [
            { id: "driver_id", label: "Driver ID" },
            { id: "driver_name", label: "Driver Name" },
            { id: "phone_number", label: "Driver Phone No." },
            { id: "total_cash_ride_count", label: "Total Cash Ride Count" },
            { id: "total_online_ride_count", label: "Total Online Ride Count" },
            { id: "total_rides", label: "Total Rides" },
            { id: "total_cash_earnings", label: "Total Cash Earnings" },
            { id: "total_online_earnings", label: "Total Online Earnings" },
            { id: "total_earnings", label: "Total Earnings" },
            { id: "total_expenses", label: "Total Expenses" },
        ],
        params: {
            client_id: true,
            start_date: true,
            end_date: true,
        },
    },
    {
        tabName: "User Wallet Report", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/wallet_transaction_report`, // API endpoint
        searchKey: "user_id",
        showTxnTypeFilter: true,
        // showUserTypeFilter: true,
        showAdminNameFilter: true,
        showUserId:true,
        columns: [
            { id: "user_id", label: "User ID" },
            { id: "txn_type", label: "Transaction Type" },
            { id: "txn_event", label: "Transaction Event" },
            { id: "amount", label: "Amount" },
            { id: "reason", label: "Reason" },
            { id: "admin_id", label: "Admin ID" },
            { id: "admin_name", label: "Admin Name"},
            { id: "logged_on", label: "Logged On" },
        ],
        params: {
            user_id: false,
            user_type: 0, // 0 stands for customer
            start_date: true,
            end_date: true,
        },
    },
    // {
    //     tabName: "Admin Wallet Report", // Tab name
    //     apiEndpoint: `${BASE_URL}/analytics/wallet_transaction_report`, // API endpoint
    //     searchKey: "admin_id",
    //     showTxnTypeFilter: true,
    //     showUserId:true,
    //     showUserTypeFilter: true,
    //     showUserIdPlacholeder:"Admin ID",
    //     columns: [
    //         { id: "admin_id", label: "Admin ID" },
    //         { id: "admin_name", label: "Admin Name"},
    //         { id: "txn_type", label: "Transaction Type" },
    //         { id: "txn_event", label: "Transaction Event" },
    //         { id: "amount", label: "Amount" },
    //         { id: "user_type", label: "User Type"},
    //         { id: "reason", label: "Reason" },
    //         { id: "logged_on", label: "Logged On" },

    //     ],
    //     params: {
    //         user_id: false,
    //         start_date: true,
    //         end_date: true,
    //         is_admin_request: 1,
    //     },
    // },
    {
        tabName: "Driver Wallet Report", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/wallet_transaction_report`, // API endpoint
        searchKey: "user_id",
        showTxnTypeFilter: true,
        showUserId:true,
        showAdminNameFilter: true,
        columns: [
            { id: "user_id", label: "Driver ID" },
            { id: "txn_type", label: "Transaction Type" },
            { id: "txn_event", label: "Transaction Event" },
            { id: "amount", label: "Amount" },
            { id: "admin_id", label: "Admin ID" },
            { id: "admin_name", label: "Admin Name"},
            { id: "reason", label: "Reason" },
            { id: "logged_on", label: "Logged On" },
        ],
        params: {
            user_id: false,
            user_type: 1, // 1 stands for driver
            start_date: true,
            end_date: true,
        },
    },
    {
        tabName: "Promotion Reports",
        apiEndpoint: `${BASE_URL}/panel/fetch_promo_redemption_overview`,
        searchKey: "promo_id",
        showCityFilter: true,
        showDateRange: true,
        showUserId: false,
        showpromoName:true,
        showpartnerName:true,
        columns: [
            { id: "promo_id", label: "Promotion ID" },
            { id: "title", label: "Title" },
            { id: "promo_type", label: "Promo Type" },
            { id: "promo_code", label: "Promo Code" },
            { id: "maximum_allowed", label: "Maximum Allowed" },
            { id: "per_user_limit", label: "Per User Limit" },
            { id: "is_active", label: "Status" },
            { id: "total_redemptions", label: "Total Redemptions" },
            { id: "total_discount_disbursed", label: "Total Discount Disbursed"},
            { id: "unique_users", label: "Unique Users"},
            { id: "partner_name",label:"Partner Name"},
            { id: "action", label: "Action" },
        ],
        params: {
            city_id: true,
            start_date: true,
            end_date: true,

        },
    },
    {
        tabName: "Driver Ride Report", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/fetch_driver_rides_report`, // API endpoint
        searchKey: "user_id",
        showCityFilter: true,
        showDateRange:true,
        showUserId:false,
        columns: [
            { id: "driver_id", label: "Driver ID" },
            { id: "driver_name", label: "Driver Name" },
            { id: "phone_number", label: "Driver Number" },
            { id: "vehicle_number", label: "Vehicle Number" },
            { id: "start_date", label: "Shift Start Date" },
            { id: "end_date", label: "Shift End Date"},
            { id: "shift_timing", label: "Shift Timing" },
            { id: "total_completed_rides_per_shift", label: "Rides Per Shift" },
            { id: "total_distance_completed_per_shift", label: "Distance Per Shift" },
            { id: "total_ride_time_completed_mins_per_shift", label: "Ride Time Per Shift" },
        ],
        params: {
            user_id: false,
            city_id: true,
            start_date: true,
            end_date: true,
        },
    },
    {
        tabName: "Driver Shift Report", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/fetch_driver_shifts_report`, // API endpoint
        searchKey: "user_id",
        showCityFilter: true,
        showDateRange:true,
        showUserId:false,
        columns: [
            { id: "driver_id", label: "Driver ID" },
            { id: "driver_name", label: "Driver Name" },
            { id: "phone_number", label: "Driver Number" },
            { id: "shift_1_date", label: "First Shift Start and End Date" },
            { id: "shift_1_time", label: "First Shift Timings" },

            { id: "shift_2_date", label: "Second Shift Start and End Date" },
            { id: "shift_2_time", label: "Second Shift Timings" },

            { id: "shift_3_date", label: "Third Shift Start and End Date" },
            { id: "shift_3_time", label: "Third Shift Timings" },
            { id: "total_duty_hours", label: "Total Duty Hours" },
            { id: "total_shifts", label: "Total Shifts" },
        ],
        params: {
            user_id: false,
            city_id: true,
            start_date: true,
            end_date: true,
        },
    },
    {
        tabName: "Latest User Reports",
        apiEndpoint: `${BASE_URL}/analytics/fetch_latest_user_report`,
        searchKey: "id",
        showCityFilter: true,
        showDateRange: true,
        showUserId: true,
        columns: [
            { id: "id", label: "ID" },
            { id: "client_id", label: "Client ID"},
            { id: "name", label: "Name" },
            { id: "user_type", label: "User Type" },
            { id: "phone_number", label: "Phone Number" },
            { id: "gender", label: "Gender"},
            { id: "email", label: "Email ID" },
            { id: "registered_city", label: "Registered City" },
            { id: "registration_date", label: "Registration Date" },
            { id: "total_trips", label: "Total Trips" },
            { id: "rating", label: "Total Ratings" },

        ],
        params: {
            user_id: false,
            city_id: true,
            start_date: true,
            end_date: true,
        },
    },
];

export default analyticsConfig;